<form novalidate #advanceForm="ngForm">
  <div class="setup">
    <div class="section-container">
      <div class="label-data label">CIR to Test</div>
      <div class="section-data">
        <div class="group networkDD">
          <div class="label" *ngIf="isAgentToJmep">CIR *</div>
          <div class="label" *ngIf="!isAgentToJmep">Downstream (Mbps) *</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            name="downstream"
            class="input-stream"
            [(ngModel)]="formField.downstream"
            #downstreamInput="ngModel"
            (ngModelChange)="downstreamUpdated()"
            min="1"
            required
          />
          <div
            class="error"
            *ngIf="
              (downstreamInput.invalid && (downstreamInput.dirty || downstreamInput.touched)) ||
              !validityStreamCheck(formField.downstream, setupService.maxDownStream, 1) ||
              !isValidYangModel(isDownStreamError)
            "
          >
            <mat-error
              *ngIf="
                formField.downstream >= 0 &&
                !validityStreamCheck(formField.downstream, setupService.maxDownStream, 1) &&
                !downstreamInput?.errors?.required
              "
              >Downstream should be {{ minCir }} to {{ setupService.maxDownStream }}</mat-error
            >
            <mat-error *ngIf="!isValidYangModel(isDownStreamError)">{{
              isDownStreamError
            }}</mat-error>

            <mat-error *ngIf="downstreamInput?.errors?.required"> required</mat-error>
          </div>
        </div>
        <div class="group networkDD field-margin" *ngIf="!isAgentToJmep">
          <div class="label">Upstream (Mbps) *</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            name="upstream"
            class="input-stream"
            [(ngModel)]="formField.upstream"
            #upstreamInput="ngModel"
            (ngModelChange)="upstreamUpdated()"
            min="1"
            required
          />
          <div
            class="error"
            *ngIf="
              (upstreamInput.invalid && (upstreamInput.dirty || upstreamInput.touched)) ||
              !validityStreamCheck(formField.upstream, setupService.maxUpStream, 1) ||
              !isValidYangModel(isUpstreamError)
            "
          >
            <mat-error
              *ngIf="
                formField.upstream >= 0 &&
                !validityStreamCheck(formField.upstream, setupService.maxUpStream, 1) &&
                !upstreamInput?.errors?.required
              "
              >Upstream should be between 1 to {{ setupService.maxUpStream }}</mat-error
            >
            <mat-error *ngIf="!isValidYangModel(isUpstreamError)">{{ isUpstreamError }}</mat-error>
            <mat-error *ngIf="upstreamInput?.errors?.required">required</mat-error>
          </div>
        </div>
      </div>
    </div>

    <div class="section-container">
      <div class="label-data label">Network Setup</div>
      <div class="section-data network">
        <div class="group">
          <div class="label">
            TCP Port
            <i class="mdi mdi-help-circle-outline" matTooltip="{{ formTooltip.tcpPort }}"></i>
          </div>
          <mat-select
            class="option-list"
            #tcpPortInput="ngModel"
            [(ngModel)]="formField.tcpPort"
            name="tcpPort"
            (selectionChange)="onTcpPortChange($event)"
            required
          >
            <mat-option *ngFor="let tcp of tcpPortData" [value]="tcp.value">{{
              tcp.name
            }}</mat-option>
          </mat-select>
          <mat-error class="error" *ngIf="isTCPPortError && !isValidYangModel(isTCPPortError)">{{
            isTCPPortError
          }}</mat-error>
        </div>
        <div class="group">
          <div class="label">DSCP</div>
          <mat-select
            class="option-list"
            #qosTypeInput="ngModel"
            [(ngModel)]="formField.tosDscp.dscp"
            name="dscpValue"
            (selectionChange)="onDscpValueChange($event)"
            required
          >
            <mat-option *ngFor="let flow of dscpFlows" [value]="flow.id"
              >{{ flow.value }} ({{ flow.id }})</mat-option
            >
          </mat-select>
        </div>
        <div class="run-exclusive-enable" *ngIf="showRunExclusive">
          <mat-slide-toggle
            color="primary"
            [checked]="formField.runExclusive"
            name="runExclusive"
            class="enable-row"
            color="primary"
            [disabled]="isRunExclusiveDisabled"
            (change)="runOnAgentChange($event)"
          >
          </mat-slide-toggle>
          <div class="run_exclusively">
            <div class="label">
              Run exclusively on agent
              <i
                class="mdi mdi-help-circle-outline"
                matTooltip="{{ formTooltip.runExclusiveOnAgent }}"
              ></i>
            </div>
          </div>
        </div>
        <div class="group" *ngIf="isAgentToJmep">
          <div class="label">JMEP Address *</div>
          <input
            matInput
            autocomplete="off"
            type="text"
            name="ipAddress"
            class="input-stream"
            [(ngModel)]="formField.ipAddress"
            #ipAddressInput="ngModel"
            [pattern]="validIPRegex"
            (ngModelChange)="onIPValueChange($event)"
            required
          />
          <div
            class="error"
            *ngIf="ipAddressInput.invalid && (ipAddressInput.dirty || ipAddressInput.touched)"
          >
            <mat-error *ngIf="ipAddressInput?.errors?.required">IP address required</mat-error>
            <mat-error *ngIf="ipAddressInput.errors?.pattern">Address is invalid</mat-error>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container window-section">
      <div class="label-data label">Window Walk</div>
      <div class="section-data">
        <div class="group networkDD">
          <div class="label">CIR Starting Percent *</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            class="input-small"
            name="cirStart"
            [(ngModel)]="formField.cirStart"
            #cirStartInput="ngModel"
            (ngModelChange)="cirStartUpdated()"
            min="1"
            max="100"
            required
          />
          <div
            class="error"
            *ngIf="
              (cirStartInput.invalid && (cirStartInput.dirty || cirStartInput.touched)) ||
              !isValidYangModel(ispercentStartWindowWalkError)
            "
          >
            <mat-error
              *ngIf="
                formField.cirStart >= 0 &&
                !isValidYangModel(ispercentStartWindowWalkError) &&
                !cirStartInput?.errors?.required
              "
              >{{ ispercentStartWindowWalkError }}</mat-error
            >
            <mat-error *ngIf="cirStartInput?.errors?.required">required</mat-error>
          </div>
        </div>
        <div class="group field-margin networkDD">
          <div class="label">
            Number of Walks *
            <i class="mdi mdi-help-circle-outline" matTooltip="{{ formTooltip.numberOfWalks }}"></i>
          </div>
          <input
            matInput
            autocomplete="off"
            type="number"
            class="input-small"
            name="noOfwalk"
            [(ngModel)]="formField.noOfwalk"
            #noOfwalkInput="ngModel"
            (ngModelChange)="validateNoOfWalk()"
            required
          />
          <div
            class="error"
            *ngIf="noOfwalkInput.invalid && (noOfwalkInput.dirty || noOfwalkInput.touched)"
          >
            <mat-error *ngIf="noOfwalkInput?.errors?.invalidRange">{{
              noOfwalkInput.errors.invalidRange
            }}</mat-error>
            <mat-error *ngIf="noOfwalkInput?.errors?.required">required</mat-error>
          </div>
        </div>
        <div class="group field-margin networkDD">
          <div class="label">Duration(sec) *</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            class="input-small"
            name="duration"
            [(ngModel)]="formField.duration"
            #durationInput="ngModel"
            (ngModelChange)="durationUpdated()"
            required
          />
          <div
            class="error"
            *ngIf="durationInput.invalid && (durationInput.dirty || durationInput.touched)"
          >
            <mat-error
              *ngIf="!durationInput?.errors?.required && durationInput?.errors?.invalidRange"
            >
              {{ durationInput.errors.invalidRange }}
            </mat-error>
            <mat-error *ngIf="durationInput?.errors?.required">required</mat-error>
          </div>
        </div>
        <div class="group field-margin noOfConn">
          <div class="label noOfConn-label">
            Number of Connections
            <i
              class="mdi mdi-help-circle-outline"
              matTooltip="{{ formTooltip.numberOfConnections }}"
            ></i>
          </div>
          <input
            matInput
            autocomplete="off"
            type="number"
            class="input-small no-Of-Connections"
            name="noOfConnections"
            [(ngModel)]="formField.connections"
            #noOfConnectionsInput="ngModel"
            placeholder="Automatic"
            (ngModelChange)="noOfConnectionsUpdated()"
            min="0"
          />
          <div
            class="error"
            *ngIf="
              (noOfConnectionsInput.invalid &&
                (noOfConnectionsInput.dirty || noOfConnectionsInput.touched)) ||
              !isValidConnectionsRange()
            "
          >
            <mat-error
              *ngIf="
                formField.connections >= 0 &&
                !isValidConnectionsRange() &&
                !noOfConnectionsInput?.errors?.required
              "
              >valid rang is 1...{{ maxConnections }}</mat-error
            >
          </div>
        </div>
      </div>
    </div>
    <div class="section-container boost-window">
      <div class="label-data label"></div>
      <div class="section-data">
        <div class="enable-section">
          <mat-slide-toggle
            [checked]="formField.saturation"
            name="enable"
            class="enable-row"
            color="primary"
            (change)="saturationChanged($event)"
          >
          </mat-slide-toggle>
          <div class="group toggle-margin">
            <div class="label">
              Add saturation window
              <i
                class="mdi mdi-help-circle-outline"
                matTooltip="{{ formTooltip.addSaturationWindow }}"
              ></i>
            </div>
          </div>
        </div>

        <div *ngIf="formField.saturation" class="dynamic-saturation">
          <div class="dynamic-saturation-enable" *ngIf="showDynamicSaturation">
            <mat-slide-toggle
              [checked]="formField.dynamicSaturation"
              name="checkDynamic"
              class="enable-row"
              color="primary"
              (change)="enableDynamicSaturation($event)"
            >
            </mat-slide-toggle>
            <div class="group toggle-margin">
              <div class="label"><b>Enable Dynamic Saturation</b></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container" *ngIf="boostInputEnable">
      <div class="label-data label"></div>
      <div class="section-data">
        <div class="dynamic-saturation-enable">
          <div class="boost-window-label">
            <div class="label">Boost Window by *</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-small"
              name="boostWindow"
              [(ngModel)]="formField.boostWindow"
              #boostWindowInput="ngModel"
              (ngModelChange)="boostWindowUpdated()"
              min="0"
              max="100"
              required
            />
            <span class="percentage">%</span>
            <div
              class="error"
              *ngIf="
                (boostWindowInput.invalid &&
                  (boostWindowInput.dirty || boostWindowInput.touched)) ||
                !validityStreamCheck(formField.boostWindow, 100, 0)
              "
            >
              <mat-error
                *ngIf="
                  formField.boostWindow >= 0 &&
                  !validityStreamCheck(formField.boostWindow, 100, 0) &&
                  !boostWindowInput?.errors?.required
                "
                >Boost Window should be 0 to 100</mat-error
              >
              <mat-error *ngIf="boostWindowInput?.errors?.required">required</mat-error>
            </div>
          </div>
          <div class="group boostDD">
            <div class="label">Boost Connection by *</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-small"
              name="boostConnection"
              [(ngModel)]="formField.boostConnection"
              #boostConnectionInput="ngModel"
              (ngModelChange)="boostConnectionUpdated()"
              min="0"
              max="100"
              required
            />
            <span class="percentage">%</span>
            <div
              class="error"
              *ngIf="
                (boostConnectionInput.invalid &&
                  (boostConnectionInput.dirty || boostConnectionInput.touched)) ||
                !validityStreamCheck(formField.boostConnection, 100, 0)
              "
            >
              <mat-error
                *ngIf="
                  formField.boostConnection >= 0 &&
                  !validityStreamCheck(formField.boostConnection, 100, 0) &&
                  !boostConnectionInput?.errors?.required
                "
                >Boost Connection should be 0 to 100</mat-error
              >
              <mat-error *ngIf="boostConnectionInput?.errors?.required">required</mat-error>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
